import type { MouseEvent } from 'react'

/**
 * Turn a link into a sheet trigger without losing the link: a plain left
 * click runs `handler` instead of navigating, while modified clicks
 * (new tab/window) and no-JS keep the `href`. Returns `undefined` without a
 * handler so the link just navigates.
 */
export function onPlainClick(handler?: () => void) {
  if (!handler) return undefined
  return (e: MouseEvent<HTMLElement>) => {
    if (e.defaultPrevented || e.button !== 0) return
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
    e.preventDefault()
    handler()
  }
}
